














































































































































































































type Prop<T> = () => T
import Vue from 'vue'
import { Validator } from 'vee-validate'
import VueScrollTo from 'vue-scrollto'
import FormValues from '@/types/form-values'
Vue.use(VueScrollTo)

export default Vue.extend({
  inject: ['$validator'],
  props: {
    values: Object as Prop<FormValues>
  },
  data() {
    return {
      choiceForYear: [] as number[]  
    }
  },
  created() {
    this.createYearSelects()
  },
  methods: {
    validate() {
      (this.$validator as Validator).validateAll().then(result => {
        if (result) this.$emit('get-form-values', this.values)
        VueScrollTo.scrollTo('.application')
      })
    },
    createYearSelects() {
      const newest = new Date().getFullYear()
      const oldest = newest - 90
      const years = [...Array(newest - oldest + 1).keys()].map(x => x + oldest)
      this.choiceForYear = years.sort((a, b) => a < b ? 1 : -1)
    }
  }
})
